import React, { useState, useEffect } from 'react';
import { Form, message } from 'antd';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Header from '../../components/Shared/Header';
import Loading from "../../components/Shared/Loading";
import { getClientInfo, updateClient } from '../../Utils/client/client';
import CustomerForm from '../../components/Client/CustomerForm';



const EditCustomer = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const param = useParams();
  const location = useLocation();
  const [clientInfo, setClientInfo] = useState(null);

  const getClientDetail = async () => {
    setLoading(true);
    try {
      const res = await getClientInfo(param.clientId);
      if (!res.data.user) {
        navigate("/admin/client/all");
        return;
      }
      setClientInfo(res.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (!location.state || !location.state.clientInfo) {
      getClientDetail();
    } else {
      setClientInfo(location.state.clientInfo);
    }
  }, [location.state, navigate]);

  useEffect(() => {
    if (clientInfo) {
      form.setFieldsValue({
        company_name: clientInfo.user.company_name,
        full_name: clientInfo.user.first_name + ' ' + clientInfo.user.last_name,
        phone_number: clientInfo.user.phone_number,
        email: clientInfo.user.email,
        address: clientInfo.user.address,
        company_logo: clientInfo.user.company_logo ? [{ thumbUrl: `data:image/png;base64,${clientInfo.user.company_logo}` }] : null
      });
    }
  }, [clientInfo, form]);

  const onFinish = async (values) => {
    setLoading(true);
    const formData = {
      ...values,
      company_logo: values.company_logo ? values.company_logo[0].thumbUrl.split(',')[1] : null,
      first_name: values.full_name.split(' ')[0],
      // store the rest of the name in last_name
      last_name: values.full_name.split(' ').slice(1).join(' ')

    };
    try {
      await updateClient(clientInfo.user.user_id, formData);
      setLoading(false);
      message.success('Client mis à jour avec succès!');
      navigate(`/admin/client/${clientInfo.user.user_id}/show-info`);
    } catch (error) {
      console.error(error);
      setLoading(false);
      message.error('Erreur lors de la mise à jour du client');
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header title="Modification client" />
      <div className="p-8">
        <CustomerForm 
          form={form} 
          onFinish={onFinish} 
          initialValues={clientInfo?.user} 
          isEditing={true} 
        />
      </div>
    </div>
  );
};

export default EditCustomer;